function NewPOIreport() {
    return  <h1>New POI report</h1> 
}  
export default NewPOIreport;     